export default __webpack_public_path__ + "static/media/warning.e3ffc554.svg";